<div class="wrapper">
    <!-- <app-appli-side-bar [sidebars]="sidebar" (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar> -->
    <app-appli-side-bar [sidebars]="sidebar" (focusEventIndex)="setFocusIndex($event)"
        (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar>

    <div class="icon_box">
        <div class="top_icon"></div>
        <div class="app_name">{{ appname }}</div>

    </div>
    <div class="remote_control"></div>
    <div class="datetime">
        {{ now_date_obj.year }}.{{ now_date_obj.month }}.{{ now_date_obj.day }} {{ now_date_obj.hhmm }}
    </div>
    <div class="main_content_wrapper">
        <div class="main_content">

            <!--レストラン-->
            <div *ngIf="hotelIndex == 0">

                <div class="floor_icon">
                    <img src="/assets/icons/com/floor.svg">
                </div>
                <div *ngIf="lang == 'jpn'">


                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">レストラン「穏坐」- ONZA -</div>
                            <div class="mess_l">
                                <p>
                                    朝食｜7:00 ～ 10:00（ラストオーダー 9:30）
                                </p>
                            </div>

                            <div class="mess_s">
                                <p>朝食は、京都産の炊きたて白米や白味噌を使った具沢山の味噌汁、</p>
                                <p>地元の老舗豆腐屋が作る南禅寺豆腐などブッフェスタイルで</p>
                                <p>ご用意しております。また、宿泊者限定のラウンジ(14:30 ~ 23:00)として</p>
                                <p>挽き立てコーヒーや菓子を無料でお楽しみいただけます。</p>
                            </div>

                            <div class="smalltext">
                                <p>※部屋着やスリッパでの来店はご遠慮ください。</p>

                            </div>
                        </div>
                        <div class="right_img img_2p">
                            <img src="/assets/hotel-info/restaurant.jpg">
                            <img src="/assets/hotel-info/restaurant_counter.jpg">
                        </div>
                    </div>
                </div>
                <div *ngIf="lang == 'eng'">
                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">Restaurant「ONZA」</div>
                            <div class="mess_l">
                                <p>Breakfast</p>
                                <p>7:00 a.m. - 10:00 a.m. (Last Order 9:30 a.m.)</p>
                            </div>

                            <div class="mess_s restaurant_mess_s">
                                <p>For breakfast, we serve freshly cooked white rice from Kyoto and</p>
                                <p>miso soup with a variety of ingredients made from white miso.</p>
                                <p>Additionally, we offer a buffet-style breakfast featuring Nanzenji</p>
                                <p>Tofu, crafted by a renowned tofu maker in Kyoto.Our lounge is</p>
                                <p>exclusively open to guests from 2:30 p.m. to 11:00 p.m. During</p>
                                <p>this time, we provide freshly ground coffee and complimentary</p>
                                <p>small snacks.</p>
                            </div>

                            <div class="smalltext">
                                <p>※Please refrain from coming in loungewear or slippers.</p>

                            </div>
                        </div>
                        <div class="right_img img_2p">
                            <img src="/assets/hotel-info/restaurant.jpg">
                            <img src="/assets/hotel-info/restaurant_counter.jpg">
                        </div>
                    </div>
                </div>
            </div>

            <!--ラウンジ-->
            <div *ngIf="hotelIndex == 1">
                <div class="floor_icon">
                    <img src="/assets/icons/com/floor.svg">
                </div>
                <div *ngIf="lang == 'jpn'">
                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">「穏坐」- ONZA - ラウンジ</div>

                            <div class="mess_l">
                                <p> 14:30 ～ 23:00</p>
                            </div>

                            <div class="mess_s">
                                <p>鰹ベースの風味豊かな和風出汁や冷茶、挽き立てコーヒーのほか</p>
                                <p>飴やナッツなどの小菓子各種をご用意しております。季節ごとに表情を</p>
                                <p>変える見世庭を愛でながらリラックスしてお過ごしいただけます。</p>
                            </div>

                            <div class="smalltext">
                                <p>※セルフサービス</p>
                                <p>※内容は変更になる場合がございます。</p>
                                <p>※部屋着やスリッパでの来店はご遠慮ください。</p>
                            </div>
                        </div>

                        <div class="right_img img_2p">
                            <img src="/assets/hotel-info/lounge_drink.jpg">
                            <img src="/assets/hotel-info/lounge_desk.jpg">
                        </div>
                    </div>
                </div>
                <div *ngIf="lang == 'eng'">
                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">「ONZA」 Lounge</div>

                            <div class="mess_l">
                                <p> 2:30 p.m. - 11:00 p.m.</p>
                            </div>

                            <div class="mess_s">
                                <p>We offer a variety of Japanese soup stocks with a rich bonito</p>
                                <p>base flavor, cold tea, freshly ground coffee, as well as an</p>
                                <p>assortment of small sweets like candies and nuts.</p>
                            </div>

                            <div class="smalltext">
                                <p>※Please note that this is a self-service area.</p>
                                <p>※The menu contents are subject to change.</p>
                                <p>※Please refrain from coming in loungewear or slippers.</p>
                            </div>
                        </div>

                        <div class="right_img img_2p">
                            <img src="/assets/hotel-info/lounge_drink.jpg">
                            <img src="/assets/hotel-info/lounge_desk.jpg">
                        </div>
                    </div>


                </div>
            </div>

            <!--コインランドリー-->
            <div *ngIf="hotelIndex == 2">
                <div class="floor_icon">
                    <img src="/assets/icons/com/floor_hour.svg">
                </div>
                <div *ngIf="lang == 'jpn'">
                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">
                                全自動洗濯乾燥機<span class="mess_l">（３台）</span>がございます。
                            </div>
                            <table class="table_Laundromat">
                                <tr>
                                    <td>
                                        洗濯 / 乾燥<span class="smalltext">（3kg まで）</span>
                                    </td>
                                    <td>
                                        600円<span class="smalltext"> （目安時間 120 分）</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        洗濯 / 乾燥<span class="smalltext">（1kg まで）</span>
                                    </td>
                                    <td>
                                        500円<span class="smalltext"> （目安時間 80 分）</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        洗濯のみ<span class="smalltext">（6kg まで）</span>
                                    </td>
                                    <td>
                                        400円<span class="smalltext"> （目安時間 35 分）</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        乾燥のみ<span class="smalltext">（5kg まで）</span>
                                    </td>
                                    <td>
                                        200円<span class="smalltext"> （目安時間 約30 分）</span>
                                    </td>
                                </tr>
                            </table>

                            <div class="smalltext">
                                <p>※ご利用の際は100円硬貨をご用意ください。</p>
                                <p>※混雑時はお待ちいただくこともございます。</p>
                                <p>※利用予約はできません。</p>
                                <p>※終了後は放置せず速やかに取り出してください。</p>
                            </div>
                        </div>

                        <div class="right_img">
                            <img src="/assets/hotel-info/laundry.jpg">
                        </div>
                    </div>
                </div>


                <div *ngIf="lang == 'eng'">
                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">
                                <p>An automatic washing and drying</p>
                                <p>machine is available.</p>
                            </div>
                            <table class="table_Laundromat">
                                <tr>
                                    <td>
                                        Wash&Dry<span class="smalltext">(less than 3kg)</span>
                                    </td>
                                    <td>
                                        600 yen<span class="smalltext"> (120 min)</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Wash&Dry<span class="smalltext"> (less than 1kg)</span>
                                    </td>
                                    <td>
                                        500 yen<span class="smalltext"> (80 min)</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Wash Only<span class="smalltext"> (less than 6kg)</span>
                                    </td>
                                    <td>
                                        400 yen<span class="smalltext"> (35 min)</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Dry Only<span class="smalltext"> (less than 5kg)</span>
                                    </td>
                                    <td>
                                        200 yen<span class="smalltext"> (approx. 30 min)</span>
                                    </td>
                                </tr>
                            </table>

                            <div class="smalltext">
                                <p>※Please have 100 yen coins ready.</p>
                                <p>※Please note that you may be asked to wait during busy times.</p>
                                <p>※you cannot make reservations for use.</p>
                                <p>※Please do not leabe the machine unattended after you finish using it.</p>
                            </div>
                        </div>

                        <div class="right_img">
                            <img src="/assets/hotel-info/laundry.jpg">
                        </div>
                    </div>


                </div>
            </div>

            <!--喫煙所-->
            <div *ngIf="hotelIndex == 3">
                <div class="floor_icon">
                    <img src="/assets/icons/com/floor.svg">
                </div>
                <div *ngIf="lang == 'jpn'">
                    <div class="rightzero_container">
                        <div class="divmessage smoking_box">
                            <div class="mess_title">
                                <p>当ホテルは全室全館禁煙です。</p>
                                <p>喫煙ルームをご利用ください。</p>
                            </div>
                            <div class="smalltext">
                                <p>※入室最大３名</p>
                                <p>※所定の場所以外で喫煙された場合、罰金３万円を申し受けます。</p>

                            </div>
                        </div>

                        <div class="right_img">
                            <img src="/assets/hotel-info/smoking.jpg">
                        </div>
                    </div>
                </div>

                <div *ngIf="lang == 'eng'">
                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">
                                <p>All rooms in the hotel are</p>
                                <p>non-smoking.</p>
                                <p>Please use the smoking rooms.</p>
                            </div>
                            <div class="smalltext">
                                <p>※Maximum of 3 persons per room.</p>
                                <p>※Smoking in areas other than the designated smoking area will result</p>
                                <p>in a 30,000 yen fine.
                                </p>

                            </div>
                        </div>

                        <div class="right_img">
                            <img src="/assets/hotel-info/smoking.jpg">
                        </div>
                    </div>

                </div>

            </div>

            <!--自動販売機 -->
            <div *ngIf="hotelIndex == 4">
                <div class="floor_icon">
                    <img src="/assets/icons/com/floor_hour.svg">
                </div>
                <div *ngIf="lang == 'jpn'">
                    <div class="machine_container">
                        <div class="machine_ul">

                            <div class="machine_icon" *ngFor="let item of machine">
                                <img [src]="item.icon_url" />
                                <div> {{ item.name }}</div>
                            </div>
                        </div>
                    </div>

                </div>

                <div *ngIf="lang == 'eng'">
                    <div class="machine_container">
                        <div class="machine_ul">

                            <div class="machine_icon" *ngFor="let item of machine">
                                <img [src]="item.icon_url" />
                                <div> {{ item.name }}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>